import type { TranslationTree } from '../translations';

export const ptBR: TranslationTree = {
  login: {
    title: 'Login',
    email: 'Email',
    password: 'Senha',
    thanks: 'Obrigado',
    submit: 'Acessar',
    submitting: 'Entrando...',
    requiredFields: 'Por favor, preencha todos os campos',
    invalidCredentials: 'Erro ao fazer login. Verifique suas credenciais.',
    planInactive: 'O plano da sua empresa está inativo. Entre em contato com o administrador.',
    forgotPassword: 'Esqueci minha senha?',
    forgotPasswordTitle: 'Recuperar senha',
    forgotPasswordDescription: 'Informe seu email para receber um código de recuperação.',
    sendResetCode: 'Enviar código',
    sendingResetCode: 'Enviando...',
    backToLogin: 'Voltar para o login',
    resetCodeSent: 'Enviamos um código para seu email.',
    resetPasswordTitle: 'Nova senha',
    resetPasswordDescription: 'Digite o código recebido e defina sua nova senha.',
    resetCode: 'Código',
    newPassword: 'Nova senha',
    confirmPassword: 'Confirmar senha',
    resetPassword: 'Alterar senha',
    resettingPassword: 'Alterando...',
    resetPasswordSuccessTitle: 'Senha alterada',
    resetPasswordSuccessDescription: 'Sua senha foi atualizada com sucesso. Você já pode entrar novamente.',
    invalidEmail: 'Informe um email válido',
    resetCodeRequired: 'Informe o código de recuperação',
    invalidResetCode: 'O código deve conter 6 dígitos',
    passwordRequired: 'Informe e confirme a nova senha',
    passwordMinLength: 'A senha deve ter pelo menos 6 caracteres',
    passwordsDoNotMatch: 'As senhas não coincidem',
    passwordResetRequestError: 'Erro ao enviar código de recuperação. Tente novamente.',
    passwordResetError: 'Erro ao alterar senha. Verifique o código e tente novamente.',
    languageLabel: 'Idioma',
    portugueseLanguage: 'Português',
    englishLanguage: 'Inglês',
  },
  common: {
    loading: 'Carregando...',
    loadingData: 'Carregando dados...',
    save: 'Salvar',
    saving: 'Salvando...',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    back: 'Voltar',
    edit: 'Editar',
    delete: 'Deletar',
    remove: 'Remover',
    processing: 'Processando...',
    notAvailable: 'N/A',
    requiredFieldsHint: '* Campos obrigatórios',
    active: 'Ativo',
    inactive: 'Inativo',
    actions: 'Ações',
    company: 'Empresa',
    companies: 'Empresas',
    language: 'Idioma',
    role: 'Função',
    name: 'Nome',
    email: 'Email',
    password: 'Senha',
    description: 'Descrição',
    cnpj: 'CNPJ',
  },
  menu: {
    rolePrefix: 'Função:',
    loading: 'Carregando...',
    menu: 'Menu',
    home: 'Home',
    generateReport: 'Gerar Relatório',
    adminPanel: 'Painel Administrativo',
    companies: 'Empresas',
    logout: 'Sair',
  },
  accessibility: {
    enableScreenReader: 'Ativar leitor de tela',
    disableScreenReader: 'Desativar leitor de tela',
    screenReaderEnabled: 'Leitor Ativado',
    screenReaderDisabled: 'Leitor Desativado',
    fontSizeControls: 'Controles de tamanho da fonte',
    decreaseFontSize: 'Diminuir tamanho da fonte',
    increaseFontSize: 'Aumentar tamanho da fonte',
    decreaseFontTitle: 'Diminuir fonte',
    increaseFontTitle: 'Aumentar fonte',
    fontIncreased: 'Fonte aumentada. Nível {level} de 4',
    fontDecreased: 'Fonte diminuída. Nível {level} de 4',
  },
  register: {
    testId: 'ID do teste',
    participantName: 'Nome do participante',
    birthDate: 'Data de Nascimento',
    startTest: 'Iniciar teste',
    checkingLicenses: 'Verificando licenças disponíveis...',
    licenseLimit: 'Limite de licenças atingido.',
    licenseContact: 'Para continuar, solicite novas licenças em contato@causale.org ou pelo WhatsApp +55 53 99189-9532.',
    companyNotIdentified: 'Não foi possível identificar a empresa do usuário.',
    licenseValidationError: 'Não foi possível validar as licenças disponíveis. Recarregue a página e tente novamente.',
  },
  instruction: {
    firstParagraph: 'Agora você vai fazer uma atividade de escolhas.',
    secondParagraph: 'Em cada pergunta, você vai ter duas opções: uma delas mostra uma quantidade de dinheiro que você poderia ganhar agora e a outra mostra uma quantia maior, mas que você só ganharia depois de um tempo.',
    thirdParagraph: 'Não existe certo ou errado, mas o importante é o que você responda pensando no que realmente preferiria se fosse de verdade.',
    start: 'Começar',
  },
  resetPassword: {
    loading: 'Carregando...',
    missingEmail: 'Email não fornecido. Faça login novamente.',
    userNotFound: 'Usuário não encontrado.',
    loadUserError: 'Erro ao carregar dados do usuário.',
    title: 'Definir Nova Senha',
    greeting: 'Olá,',
    firstAccessSubtitle: 'Este é seu primeiro acesso. Por favor, defina uma nova senha.',
    oldPassword: 'Senha Antiga',
    newPassword: 'Nova Senha',
    confirmPassword: 'Confirmar Nova Senha',
    requirementsTitle: 'Requisitos da senha:',
    minLengthRequirement: 'Pelo menos 6 caracteres',
    matchRequirement: 'As senhas devem coincidir',
    fillAllFields: 'Preencha todos os campos',
    userNotIdentified: 'Usuário não identificado',
    resetError: 'Erro ao redefinir senha. Tente novamente.',
    saving: 'Salvando...',
    submit: 'Definir Senha',
    footer: 'Após definir sua senha, você será redirecionado para o login.',
  },
  reports: {
    loadError: 'Erro ao carregar informações. Por favor, faça login novamente.',
    selectCompanyFullPeriod: 'Selecione uma empresa para preencher todo o período.',
    companyCreationDateMissing: 'Não foi possível identificar a data de criação da empresa.',
    companyCreationDateInvalid: 'A data de criação da empresa é inválida.',
    fillFullPeriodError: 'Erro ao preencher todo o período. Por favor, tente novamente.',
    selectCompanyReport: 'Selecione uma empresa para gerar o relatório.',
    defaultCompanyFileName: 'empresa',
    reportSuccess: 'Relatório gerado com sucesso!',
    recordsFound: 'registro(s) encontrado(s).',
    noRecordsFound: 'Nenhum registro encontrado para o período selecionado.\n\nVerifique:\n- Se existem dados cadastrados para a empresa\n- Se o período selecionado está correto',
    reportError: 'Erro ao gerar o relatório. Por favor, tente novamente.',
    selectCompanyAndPeriod: 'Selecione a empresa e o período',
    selectPeriod: 'Selecione o período',
    company: 'Empresa',
    startDate: 'Data Inicial',
    endDate: 'Data Final',
    loadingPeriod: 'Carregando período...',
    fullPeriod: 'Todo o período',
    generating: 'Gerando...',
    downloadReport: 'Baixar Relatório',
    backHome: 'Voltar ao início',
    notAvailable: 'N/A',
    reportFilePrefix: 'relatorio_delay_discounting',
    filePeriodSeparator: 'ate',
    dataSheet: 'Dados',
    documentationSheet: 'Documentação',
    field: 'Campo',
    fieldDescription: 'Descrição',
    recordId: 'Record ID',
    participantName: 'Nome',
    birthDate: 'Data Nascimento',
    applicator: 'Aplicador',
    immediateValue: 'Valor Imediato',
    delayedValue: 'Valor Atrasado',
    responseIndex: 'R{number} Índice',
    responseTime: 'R{number} Tempo (s)',
    responseChoice: 'R{number} Escolha',
    startedAt: 'Iniciado em',
    completedAt: 'Completado em',
    totalTimeSeconds: 'Tempo Total (s)',
    immediateChoice: 'Imediato',
    delayedChoice: 'Atrasado',
    recordIdDescription: 'Identificador único do registro no sistema, gerado automaticamente para cada participante',
    participantNameDescription: 'Nome completo do participante',
    birthDateDescription: 'Data de nascimento do participante (formato: DD/MM/AAAA ou AAAA-MM-DD)',
    applicatorDescription: 'Nome do usuário que aplicou o teste',
    immediateValueDescription: 'Valor monetário da recompensa imediata apresentada nas escolhas',
    delayedValueDescription: 'Valor monetário da recompensa atrasada apresentada nas escolhas',
    responseIndexDescription: 'Índice da opção de atraso apresentada na Resposta {number}',
    responseTimeDescription: 'Tempo em segundos que o participante levou para fazer a escolha na Resposta {number}',
    responseChoiceDescription: 'Escolha feita pelo participante na Resposta {number} (valores: "Imediato" ou "Atrasado")',
    ed50Description: 'Atraso efetivo em que o participante é indiferente entre as opções. Ponto onde a recompensa atrasada tem 50% do valor da recompensa imediata.',
    kDescription: 'Parâmetro K da função hiperbólica de desconto temporal. Valores maiores indicam maior impulsividade/desconto.',
    startedAtDescription: 'Data e hora em que o participante iniciou a tarefa',
    completedAtDescription: 'Data e hora em que o participante concluiu a tarefa',
    totalTimeDescription: 'Tempo total em segundos para completar toda a tarefa',
  },
  profile: {
    title: 'Meu Perfil',
    userInformation: 'Informações do Usuário',
    name: 'Nome:',
    email: 'Email:',
    company: 'Empresa:',
    role: 'Função:',
    changePassword: 'Alterar Senha',
    currentPassword: 'Senha Atual',
    newPassword: 'Nova Senha',
    confirmNewPassword: 'Confirmar Nova Senha',
    passwordRequirement: 'A senha deve ter pelo menos 6 caracteres',
    changing: 'Alterando...',
  },
  admin: {
    adminPanel: 'Painel Administrativo',
    save: 'Salvar',
    saving: 'Salvando...',
    cancel: 'Cancelar',
    delete: 'Deletar',
    edit: 'Editar',
    back: 'Voltar',
    loadingData: 'Carregando dados...',
    actions: 'Ações',
    notAvailable: 'N/A',
    active: 'Ativo',
    inactive: 'Inativo',
    company: 'Empresa',
    companies: 'Empresas',
    name: 'Nome',
    email: 'Email',
    password: 'Senha',
    role: 'Função',
    description: 'Descrição',
    language: 'Idioma',
    requiredFieldsHint: '* Campos obrigatórios',
    causalePanel: 'Painel Causale',
    licenseUsage: 'Uso de Licenças',
    used: 'Utilizadas',
    remaining: 'Restantes',
    total: 'Total',
    percentageUsed: 'utilizado',
    listUsers: 'Listar Usuários',
    listConfigs: 'Listar Configurações',
    newUser: 'Novo Usuário',
    manageTests: 'Gerenciar Testes',
    users: 'Usuários',
    userSingular: 'usuário',
    userPlural: 'usuários',
    foundSingular: 'encontrado',
    foundPlural: 'encontrados',
    noRole: 'Sem função',
    noCompany: 'Sem empresa',
    myCompany: 'Minha Empresa',
    usersLoadError: 'Não foi possível carregar os usuários',
    usersFilterError: 'Não foi possível filtrar os usuários',
    userDeleteError: 'Não foi possível deletar o usuário',
    usersBulkDeleteError: 'Não foi possível deletar os usuários selecionados',
    loadingUsers: 'Carregando usuários...',
    searchUsers: 'Buscar por nome, e-mail ou função',
    allCompanies: 'Todas as empresas',
    selectAll: 'Selecionar todos',
    deleteSelected: 'Excluir selecionados',
    selected: 'selecionado',
    selectedPluralSuffix: 's',
    selectItem: 'Selecionar item',
    cannotDeleteOwnAccount: 'Você não pode excluir a própria conta',
    noUsersFound: 'Nenhum usuário encontrado',
    deleteUser: 'Deletar usuário',
    deleteUserMessage: 'Tem certeza que deseja deletar <strong>{name}</strong>? Esta ação não pode ser desfeita.',
    deleteSelectedUsers: 'Excluir usuários selecionados',
    deleteSelectedUsersMessage: 'Tem certeza que deseja deletar <strong>{count}</strong> usuário{plural}? Esta ação não pode ser desfeita.',
    viewDetails: 'Ver detalhes',
    addUser: 'Adicionar Usuário',
    loadUserDataError: 'Não foi possível carregar dados do usuário',
    userWithoutCompany: 'Usuário sem empresa associada',
    insufficientPermission: 'Permissão insuficiente para adicionar usuários',
    noAccessLevelAvailable: 'Nenhum nível de acesso disponível',
    noCompanyAvailable: 'Nenhuma empresa disponível',
    loadDataPermissionError: 'Erro ao carregar dados. Verifique suas permissões.',
    fillName: 'Por favor, preencha o nome',
    fillEmail: 'Por favor, preencha o email',
    fillPassword: 'Por favor, preencha a senha',
    selectAccessLevel: 'Por favor, selecione um nível de acesso',
    selectCompany: 'Por favor, selecione uma empresa',
    createUserError: 'Erro ao criar usuário. Verifique os dados e tente novamente.',
    loadDataErrorTitle: 'Erro ao carregar dados',
    noCompaniesPermission: 'Nenhuma empresa disponível. Verifique suas permissões.',
    noAccessLevelPermission: 'Nenhum nível de acesso disponível. Verifique suas permissões.',
    accessLevel: 'Nível de Acesso',
    creating: 'Criando...',
    createUser: 'Criar Usuário',
    editUser: 'Editar Usuário',
    loadingUserData: 'Carregando dados do usuário...',
    nameRequired: 'Nome é obrigatório',
    emailRequired: 'Email é obrigatório',
    roleRequired: 'Função é obrigatória',
    companyRequired: 'Empresa é obrigatória',
    updateUserError: 'Erro ao atualizar usuário. Tente novamente.',
    loadingRoles: 'Carregando funções...',
    saveChanges: 'Salvar Alterações',
    testConfigs: 'Configurações de Testes',
    configSingular: 'configuração',
    configPlural: 'configurações',
    registeredSingular: 'cadastrada',
    registeredPlural: 'cadastradas',
    configLoadUserError: 'Não foi possível carregar os dados do usuário',
    configLoadError: 'Não foi possível carregar as configurações',
    loadingConfigs: 'Carregando configurações...',
    delayedValue: 'Valor Atrasado',
    immediateValue: 'Valor Adiantado',
    currency: 'Moeda',
    createdAt: 'Criado em',
    noConfigFound: 'Nenhuma configuração encontrada',
    createFirstConfig: '+ Criar primeira configuração',
    configCreateTitle: 'Configurações para aplicação do Teste',
    createConfigSuccess: 'Configuração adicionada com sucesso!',
    createConfigError: 'Erro ao adicionar configuração. Verifique os dados e tente novamente.',
    addConfig: 'Adicionar Configuração',
    createConfig: 'Criar Configuração',
    configNotFound: 'Configuração não encontrada',
    configLoadErrorShort: 'Erro ao carregar configuração',
    fillAllFields: 'Por favor, preencha todos os campos!',
    configIdNotFound: 'Erro: ID da configuração não encontrado!',
    updateConfigError: 'Erro ao atualizar configuração. Verifique os dados e tente novamente.',
    loadingConfig: 'Carregando configuração...',
    editConfig: 'Editar Configuração',
    appliedTests: 'Gerenciar Testes Aplicados',
    searchTests: 'Buscar por nome, record ID ou empresa',
    clearSearch: 'Limpar busca',
    totalPrefix: 'Total:',
    loadingTests: 'Carregando testes...',
    noTestsForFilters: 'Nenhum teste encontrado para os filtros aplicados',
    noTestsFound: 'Nenhum teste encontrado',
    testsWillAppear: 'Os testes aplicados aparecerão aqui',
    rowsPerPage: 'Linhas por página',
    confirmDelete: 'Confirmar Exclusão',
    confirmDeleteTestQuestion: 'Tem certeza que deseja excluir este teste?',
    irreversibleAction: 'Esta ação não pode ser desfeita',
    testDeletedSuccess: 'Teste "{name}" excluído com sucesso!',
    testDeleteError: 'Erro ao excluir teste. Tente novamente.',
    recordId: 'Record ID',
    time: 'Tempo',
    ED50: 'ED50',
    K: 'K',
    companiesRegistered: 'empresas cadastradas',
    addCompany: 'Adicionar Empresa',
    activePlural: 'Ativas',
    licenses: 'Licenças',
    usedShort: 'Usadas',
    searchCompanies: 'Buscar por empresa, descrição ou CNPJ',
    loadingCompanies: 'Carregando empresas...',
    loadCompaniesError: 'Não foi possível carregar as empresas.',
    status: 'Status',
    createdIn: 'Criada em',
    noDescription: 'Sem descrição',
    editCompany: 'Editar empresa',
    removeCompany: 'Remover empresa',
    noCompaniesFound: 'Nenhuma empresa encontrada',
    addCompanyTitle: 'Adicionar Empresa',
    editCompanyTitle: 'Editar Empresa',
    close: 'Fechar',
    noLanguage: 'Sem idioma',
    activePlan: 'Plano ativo',
    savingCompany: 'Salvando...',
    removeCompanyTitle: 'Remover Empresa',
    companyHasTests: 'A empresa {name} possui {count} testes vinculados.',
    confirmRemoveCompany: 'Tem certeza que deseja remover {name}?',
    companyTestsPreservedWarning: 'A empresa será removida da listagem, mas os testes serão preservados no histórico.',
    typeCompanyName: 'Digite o nome da empresa',
    removing: 'Removendo...',
    companyNameRequired: 'Nome da empresa é obrigatório.',
    licensesInvalid: 'Licenças deve ser um número inteiro maior ou igual a zero.',
    companyUpdated: 'Empresa atualizada com sucesso.',
    companyAdded: 'Empresa adicionada com sucesso.',
    saveCompanyError: 'Não foi possível salvar a empresa.',
    typeExactCompanyName: 'Digite o nome exato da empresa para confirmar a remoção.',
    companyRemovedWithHistory: 'Empresa removida da listagem e testes preservados no histórico.',
    companyRemoved: 'Empresa removida com sucesso.',
    explicitConfirmationRequired: 'Confirmação explícita necessária.',
    removeCompanyError: 'Não foi possível remover a empresa.',
    unlimited: 'Ilimitado',
  },
};
